import { UserId } from '@cibo/core'
import { useOrgUser } from '@cibo/profile'
import { Box, Skeleton, Stack } from '@mui/material'

export const UserRefCell = ({ userId }: { userId: UserId }) => {
  const user = useOrgUser(userId)
  if (user.isLoading) {
    return (
      <Stack direction="row" spacing={1}>
        <Skeleton variant="text" width={48} />
        <Skeleton variant="text" width={53} />
      </Stack>
    )
  }
  return user.data ? (
    <Box data-testid={`userCell-${userId}`}>{user.data?.displayNameFull}</Box>
  ) : (
    <></>
  )
}
